<template>
  <Menu ref="sideMenu" width="auto" :active-name="activeName" :open-names="openName">
    <template v-for="menu in menus">
      <template v-if="!(menu.hiddenInFabric && isFabric)">
        <MenuItem v-if="!menu.children" :key="menu.id" :name="menu.id" :to="menu.route">
          <Icon :type="menu.icon"> </Icon>
          <span>{{ menu.title }}</span>
        </MenuItem>
        <Submenu v-else :key="menu.id" :name="menu.id">
          <template slot="title">
            <Icon :type="menu.icon"> </Icon>
            {{ menu.title }}
          </template>
          <template v-for="submenu in menu.children">
            <MenuItem
              v-if="!(submenu.hiddenInFabric && isFabric)"
              :key="submenu.id"
              :name="submenu.id"
              :to="submenu.route"
            >
              <span>{{ submenu.title }}</span>
            </MenuItem>
          </template>
        </Submenu>
      </template>
    </template>
  </Menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Leftbar',

  data() {
    return {
      menus: [],
    }
  },

  computed: {
    ...mapState(['isFabric', 'nodeIdForFabric']),
    activeName() {
      if (!this.isFabric) {
        return this.$route.path.split('/')[1]
      }
      const reg = /\/([^/]+)\/.+/
      const matchResult = this.$route.path.match(reg)
      return (matchResult && matchResult[1]) || ''
    },
    openName() {
      let currentName = ''
      const path = this.$route.path.split('/')[1]
      if (['change_password', 'language', 'theme'].includes(path)) {
        currentName = 'settings'
      } else if (['users', 'roles'].includes(path)) {
        currentName = 'admin'
      }
      return [currentName]
    },
  },

  created() {
    this.createMenus()
  },

  methods: {
    createMenus() {
      if (this.isFabric) {
        this.menus.push({
          id: 'nodes',
          title: this.$t('nodes.currentNode'),
          icon: 'md-share',
          route: `/nodes/${this.nodeIdForFabric}/stream`,
        })
      } else {
        this.menus.push({
          id: 'nodes',
          title: this.$t('nodes.nodes'),
          icon: 'md-share',
          route: '/nodes',
        })
      }
      this.menus = this.menus.concat([
        {
          id: 'admin',
          title: this.$t('admin.admin'),
          icon: 'md-people',
          hiddenInFabric: true,
          children: [
            {
              id: 'users',
              title: this.$t('admin.users'),
              route: '/users',
            },
            {
              id: 'roles',
              title: this.$t('admin.roles'),
              route: '/roles',
            },
          ],
        },
        {
          id: 'settings',
          title: this.$t('settings.settings'),
          icon: 'md-settings',
          children: [
            {
              id: 'change_password',
              title: this.$t('common.changePassword'),
              route: '/change_password',
              hiddenInFabric: true,
            },
            {
              id: 'language',
              title: this.$t('common.language'),
              route: this.createRoutePath('/language'),
            },
            {
              id: 'theme',
              title: this.$t('settings.theme'),
              route: this.createRoutePath('/theme'),
            },
          ],
        },
        {
          id: 'help',
          title: this.$t('help.help'),
          icon: 'md-help-circle',
          route: this.createRoutePath('/help'),
        },
      ])
    },
    createRoutePath(rawPath) {
      if (this.isFabric) {
        return `${rawPath}/${this.nodeIdForFabric}`
      }
      return rawPath
    },
  },
}
</script>

<style lang="scss">
.ivu-layout-sider {
  background: #333844 !important;
  padding: 36px 20px 24px;
}
.ivu-menu-light {
  background: #333844 !important;
}
.ivu-menu {
  color: #a8acb6 !important;
  .ivu-menu-item > i {
    font-size: 18px;
    margin-right: 12px;
    position: relative;
    top: 2px;
  }
}
.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
  padding: 10px 20px !important;
}
.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
  margin-bottom: 16px;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  color: #fff !important;
  background: #00b173 !important;
  border-radius: 8px;
  box-shadow: 2px 2px 6px 0px #00b1738c;
  &::after {
    width: 0px !important;
  }
}
.ivu-menu-item span {
  position: relative;
  top: 1px;
}
</style>
